// Hide empty rich-text spacer blocks without changing stored article content.
document.querySelectorAll('.article-reading .rte p, .article-reading .rte h1, .article-reading .rte h2, .article-reading .rte h3, .article-reading .rte h4').forEach((block) => {
  if (!block.textContent.trim() && !block.querySelector('img, video, audio, iframe, input, svg')) block.hidden = true;
});
